// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container___6V3Ei","item":"styles-module__item___3ur10","text":"styles-module__text___TGCBB","bold":"styles-module__bold___65RM0"};